import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TypeEntreprise } from 'src/app/shared/models/typeEntreprise';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class TypeEntrepriseService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllTypeEntreprise(): Observable<TypeEntreprise[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.typeEntrepriseUrl}/all`,
			'getAllTypeEntreprise'
		);
	}

	importTypeEntreprise(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'typeEntreprise.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.typeEntrepriseUrl}/import`,
			`importTypeEntreprise`,
			formData
		);
	}

	getTypeEntrepriseById(id: number): Observable<TypeEntreprise> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.typeEntrepriseUrl}/get/${id}`,
			'getTypeEntrepriseById'
		);
	}

	updateTypeEntreprise(typeEntreprise: TypeEntreprise): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.typeEntrepriseUrl}/update/${typeEntreprise.id}`,
			'updateTypeEntreprise',
			typeEntreprise
		);
	}

	addTypeEntreprise(typeEntreprise: TypeEntreprise): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.typeEntrepriseUrl}/add`,
			'addTypeEntreprise',
			typeEntreprise
		);
	}

	deleteTypeEntreprise(typeEntrepriseId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.typeEntrepriseUrl}/delete/${typeEntrepriseId}`,
			`deleteTypeEntreprise`
		);
	}
}
